import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import 'dropzone/dist/min/dropzone.min.css'
import React, { Component } from 'react'
import DropzoneComponent from 'react-dropzone-component'
import 'react-dropzone-component/styles/filepicker.css'
import EventBus from '../EventBus.js'
import './dropzone.scss'

class DocumentUploaderDropZone extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            documents: this.props.documents || [],
            fileTypes: this.props.fileTypes || ['.pdf', '.docx', '.xlsx', '.pptx', '.jpg', '.jpeg', '.png'],
        }
        const defaultCallback = () => { }
        this.onUpdateDocumentList = this.props.onUpdateDocumentList || defaultCallback
        this.maxFiles = this.props.maxFiles || 1
        this.dropZone = null
        this.addedFile = this.addedFile.bind(this)
        this.sending = this.sending.bind(this)
        this.removedFile = this.removedFile.bind(this)
        this.initDropZone = this.initDropZone.bind(this)
        this.maxFilesExceeded = this.maxFilesExceeded.bind(this)
        this.handleEvents = this.handleEvents.bind(this)
        EventBus.listen(EventBus.TopicUploaderDocumentsLoaded, 'template-uploader-dropzone', this.handleEvents)
    }

    handleEvents(event) {
        this.setState({
            documents: event.getData().documents
        }, () => {
            this.updateUploadedDocuments()
        })
    }

    addedFile(file) {
        const json = JSON.parse(file.xhr.response)
        this.state.documents.push(json)
        this.onUpdateDocumentList(this.state.documents)
    }

    sending(file, xhr, formData) {
        formData.append("allowedFileTypes", this.state.fileTypes)
    }

    removedFile(file) {
        const json = JSON.parse(file.xhr.response)
        if (!AppContext?.getUserLoggedIn()) {
            this.state.documents = this.state.documents.filter(doc => json.id !== doc.id)
            this.onUpdateDocumentList(this.state.documents)
        } else {
            AppContext.getApiClient().delete('/files/' + json.id).then(res => {
                this.state.documents = this.state.documents.filter(doc => res.id !== doc.id)
                this.onUpdateDocumentList(this.state.documents)
            })
        }
    }

    updateUploadedDocumentsFromDocuments(documents){
        this.setState({
            documents,
        }, this.updateUploadedDocuments)
    }

    updateUploadedDocuments() {
        this.state.documents.map(document => {
            // Create the mock file:
            let mockFile = {
                name: document.attributes.originalFileName,
                size: document.attributes.size,
                xhr: {
                    response: JSON.stringify(document),
                }
            };
            // Call the default addedfile event handler
            this.dropZone.emit("addedfile", mockFile);
            // Make sure that there is no progress bar, etc...
            this.dropZone.emit("complete", mockFile);
            // And optionally show the thumbnail of the file:
            this.dropZone.emit("thumbnail", mockFile, '/images/file.png');
            // If you use the maxFiles option, make sure you adjust it to the
            // correct amount:
            this.dropZone.options.maxFiles = this.dropZone.options.maxFiles - 1;
        })
    }

    initDropZone(dropZone) {
        this.dropZone = dropZone
        this.updateUploadedDocuments()
    }

    maxFilesExceeded(file) {
        this.dropZone.removeFile(file)
    }

    render() {
        const componentConfig = {
            iconFiletypes: this.state.fileTypes,
            showFiletypeIcon: true,
            postUrl: this.props.accountId ? `/accounts/${this.props.accountId}/upload/files` :
            AppContext.addApiKeysAsQueryParametersToPath('/upload-files'),
        }

        const djsConfig = {
            autoProcessQueue: true,
            addRemoveLinks: true,
            maxFiles: this.maxFiles,
            dictDefaultMessage: '',
        }
        const eventHandlers = {
            success: this.addedFile,
            sending: this.sending,
            removedfile: this.removedFile,
            init: this.initDropZone,
            maxfilesexceeded: this.maxFilesExceeded,
        }

        return (
            <DropzoneComponent config={componentConfig}
                eventHandlers={eventHandlers}
                djsConfig={djsConfig} />
        );
    }
}

export default DocumentUploaderDropZone





// WEBPACK FOOTER //
// ./src/common/document-uploader/dropzone.component.jsx